import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  list: [],
  selected: {},
  isLoaded: false,
};

const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    setNotification: (state, { payload }) => {
      state.list = payload;
      state.isLoaded = true;
    },
    addNotificationToList: (state, { payload }) => {
      state.list = [...state.list, payload];
    },
    updateNotificationList: (state, { payload }) => {
      console.log('[notificationSlice] Payload:', payload);
      state.list = state.list.map((item) =>
        item.id === payload.id ? payload : item
      );
    },

    removeNotificationFromList: (state, { payload }) => {
      state.list = state.list.filter((item) => item.id !== payload);
    },
    setSelectedNotification: (state, { payload }) => {
      state.selected = payload;
    },
    clearSelectedNotification: (state, { payload }) => {
      state.selected = {};
    },
  },
});

export const {
  setNotification,
  addNotificationToList,
  removeNotificationFromList,
  setSelectedNotification,
  clearSelectedNotification,
  updateNotificationList,
} = notificationSlice.actions;
export default notificationSlice.reducer;
